var _rect, _path, _path2, _rect2, _rect3, _rect4, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppropriatenessAssessmentDefault(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 91,
    viewBox: "0 0 73 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.22656,
    width: 57.3534,
    height: 56.443,
    rx: 8,
    fill: "#415360"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.93555 60.1775H23.4844V63.113H2.93555C1.31435 63.113 3.57481e-05 61.7987 0 60.1775V11.7419H2.93555V60.1775Z",
    fill: "#E6E8EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 84H68V91H44V84Z",
    fill: "current"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 18,
    y: 41,
    width: 17,
    height: 4,
    rx: 2,
    fill: "current"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 18,
    y: 28,
    width: 36,
    height: 4,
    rx: 2,
    fill: "current"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 18,
    y: 15,
    width: 36,
    height: 4,
    rx: 2,
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6961 84H45.1892C44.957 84 44.7314 83.9203 44.5565 83.7675C43.3832 82.7413 42.0255 81.215 41.4175 80.4884C41.3871 80.4522 41.36 80.4143 41.3352 80.374L31.3424 64.1357C31.1344 63.7977 31.1443 63.3669 31.3971 63.0609C32.119 62.1869 33.4501 60.8574 35.0861 60.0138C37.0529 58.9997 39.3803 61.2177 40.3643 61.9229C40.4081 61.9543 40.449 61.9875 40.4879 62.0247L43.1383 64.5627C43.7743 65.1716 44.8299 64.7209 44.8299 63.8404V38C44.8299 37.4477 45.2776 37 45.8299 37H48.2304C48.7826 37 49.2304 37.4477 49.2304 38V51.5586C49.2304 52.1109 49.6781 52.5586 50.2304 52.5586H52.0675C52.6198 52.5586 53.0675 52.1109 53.0675 51.5586V49.7153C53.0675 49.163 53.5152 48.7153 54.0675 48.7153H55.774C56.3262 48.7153 56.774 49.163 56.774 49.7153V53.1793C56.774 53.7316 57.2217 54.1793 57.774 54.1793H59.6111C60.1634 54.1793 60.6111 53.7316 60.6111 53.1793V52.3084C60.6111 51.7561 61.0588 51.3084 61.6111 51.3084H63.6319C64.1842 51.3084 64.6319 51.7561 64.6319 52.3084V54.4759C64.6319 55.0281 65.0796 55.4759 65.6319 55.4759H67.6818C68.1166 55.4759 68.469 55.1234 68.469 54.6887C68.469 54.2539 68.8214 53.9015 69.2562 53.9015H70.8749C71.4218 53.9015 71.8672 54.3369 71.8745 54.8837C71.9775 62.6495 72.1021 76.0049 71.8612 78.4897C71.6174 81.0034 68.0064 83.111 66.0676 83.9267C65.95 83.9761 65.8236 84 65.6961 84Z",
    stroke: "#E6E8EC",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppropriatenessAssessmentDefault);
export default __webpack_public_path__ + "static/media/AppropriatenessAssessmentDefault.ec872d82012b333ab7c21f605f18a399.svg";
export { ForwardRef as ReactComponent };